enum SyncIntegrationNames {
  gong = 'gong',
  helpscout = 'helpscout',
  intercom = 'intercom',
  zendesk = 'zendesk',
  api = 'api',
}

export default SyncIntegrationNames;
